<!-- eslint-disable -->
<template lang="pug">
    cs-modal.change-department__modal(@close="$emit('close')", :is-blur="true")
        div(slot='header')
            | {{ $i18n.t('support.support_ticketUpdating') }}
        .change-department
            label.change-department__label
                | {{ $i18n.t('support.support_ticketUpdating_from') }}
            .change-department__from
                | {{ this.$i18n.t('support.support_departmentName_' + department.type) }}
            label.change-department__label
                | {{ $i18n.t('support.support_ticketUpdating_to') }}
            cs-multiselect.change-department__multiselect(
                :options='departments',
                label='name',
                :show-labels='false',
                :placeholder="$i18n.t('support.support_createTicket_chooseDepartment')",
                track-by='id',
                :max-height='150',
                :multiple='false',
                :allow-empty="false",
                v-model='newDepartment',
                v-validate="'required'",
                data-vv-value-path='innerValue',
                :hide-selected="true"
            )
                span(slot='noResult')
                    | {{ $i18n.t('conversations.conversations_createMessage_notFound') }}
        .change-department__buttons
            cs-button(
                color="blue"
                @click="$emit('update', newDepartment.id); $emit('close')"
            )
                | {{ $i18n.t('support.support_updateTicket') }}
</template>

<script>
    /*eslint-disable*/
    import CsModal from '../elements/CsModal.vue';
    import DepartmentsApi from '../api/communication/departments';

    export default {
        mounted () {
            this.fetchDepartments();
        },
        props: {
            department: Object,
        },
        data () {
            return {
                departments: [],
                newDepartment: null,
            };
        },
        components: {
            CsModal
        },
        methods: {
            fetchDepartments () {
                DepartmentsApi.list().then((data) => {
                    this.departments = data.map(department => {
                        department.name = this.$i18n.t('support.support_departmentName_' + department.type);
                        department.$isDisabled = this.department.id === department.id;
                        return department;
                    });
                    this.newDepartment = this.departments.find(department => !department.$isDisabled);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .change-department__modal .modal__body {
        min-height: 400px;
    }

    .change-department__label {
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        display: flex;
        margin: 10px 0;
    }

    .change-department__from {
        text-align: left;
        font-weight: 500;
    }

    .change-department__multiselect {
        margin-bottom: 60px;
    }

    .change-department__buttons {
        display: flex;
        justify-content: flex-end;
    }
</style>
